import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/kiosk/floor_price_rule.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
/**
* Description: This module defines a Rule which sets the floor price for items of
* type T.
*
* Configuration:
*
* - floor_price - the floor price in SAFELET.
*
* Use cases:
*
* - Defining a floor price for all trades of type T.
* - Prevent trading of locked items with low amounts (e.g. by using purchase_cap).
*/
const $moduleName = "@local-pkg/kiosk::floor_price_rule";
new MoveStruct({
	name: `${$moduleName}::Rule`,
	fields: { dummy_field: bcs.bool() }
});
new MoveStruct({
	name: `${$moduleName}::Config`,
	fields: { floor_price: bcs.u64() }
});
/**
* Creator action: Add the Floor Price Rule for the `T`. Pass in the
* `TransferPolicy`, `TransferPolicyCap` and `floor_price`.
*/
function add(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [
		null,
		null,
		"u64"
	];
	const parameterNames = [
		"policy",
		"cap",
		"floorPrice"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "floor_price_rule",
		function: "add",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
/** Buyer action: Prove that the amount is higher or equal to the floor_price. */
function prove(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["policy", "request"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "floor_price_rule",
		function: "prove",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { add, prove };

//# sourceMappingURL=floor_price_rule.mjs.map